import BirdForm from './BirdForm';

export function CreateBirdForm() {
  return (
    <>
      <BirdForm formName="bird" />
    </>
  );
}
